// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--wuEgk";
export var checkbox_label = "checkbox-module--checkbox_label--QbdLW";
export var disabled = "checkbox-module--disabled--RIkxk";
export var wrapper = "checkbox-module--wrapper--Q8xrx";